/**
* 自定义页面数据
*/
const frontEndPageCustomParam = {
  
getFrontEndPageCustomParam: "/api/getFrontEndPageCustomParam",//获取页面自定义数据
setFrontEndPageCustomParam: "/api/setFrontEndPageCustomParam",//设置页面自定义数据
deleteFrontEndPageCustomParam: "/api/deleteFrontEndPageCustomParam",//删除页面自定义数据
getMyFrontEndPageCustomParam: "/api/getMyFrontEndPageCustomParam",//获取自身自定义页面数据
}

export default frontEndPageCustomParam